import { StyleSheet, Image } from "react-native";
import { View, Text } from "../../components/Themed";
import Colors from "../../constants/Colors";

export default function OpenHouseAlreadyCompleted() {
  return (
    <View style={styles.container}>
      <Image
        resizeMode="contain"
        source={require("../../assets/brivity.png")}
        style={{ height: "45%", width: "45%", maxHeight: 200, maxWidth: 200 }}
      />
      <View style={styles.content}>
        <Text
          size={24}
          weight="Bold"
          style={styles.title}
          lightColor={Colors.nuetral_grey_700}
        >
          This Open House Has Ended
        </Text>

        <Text
          size={16}
          style={styles.message}
          lightColor={Colors.nuetral_grey_700}
        >
          Please contact the listing agent for more information about this
          property.
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.base_colors_white,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  content: {
    width: "100%",
    maxWidth: 400,
    alignItems: "center",
    marginTop: 20,
  },
  title: {
    textAlign: "center",
    marginBottom: 16,
  },
  message: {
    textAlign: "center",
    marginBottom: 32,
  },
});
